<!-- Node -->
<div
  class="tree-node"
  [attr.data-id]="sanitizedID"
  (click)="handleNodeClick($event, node)"
  [ngClass]="{
    'tree-node--light': theme === treeTheme.Light,
    'tree-node--themed': theme === treeTheme.Themed,
    'tree-node--hidden': !node.boolState.shown,
    'tree-node--selected': checked,
    'tree-node--unpickable': !node.boolState.pickable && isLoft
  }">

  <!-- Expander -->
  <div 
    appEventFence
    (click)="handleExpandClick(node, node.boolState.expanded)"
    class="tree-node__expand" 
    [class.tree-node__expand--open]="node.boolState.expanded" 
    *ngIf="nested && hasChildren">

    <app-icon icon="caret-right"></app-icon>
  </div>

  <!-- Label -->
  <div class="tree-node__label" [ngClass]="{'tree-node__label--padded': !hasChildren && nested}">
    {{ node.label }}
  </div>

  <!-- Visible -->
  <div class="tree-node__visible" (click)="toggleVisible(node)" appEventFence>
    <app-icon icon="eye" size="xs" class="tree-node__eye"></app-icon>
    <app-icon icon="eye-slash" size="xs" class="tree-node__eye-slash"></app-icon>
  </div>

  <app-node-actions [node]="node" appEventFence></app-node-actions>

  <!-- Layer Order -->
  <input
    type="text"
    [value]="node.numState.layer"
    (blur)="handleLayerOrder($event, node)"
    (keyup)="handleLayerOrder($event, node)"
    class="input tree-node__layer-order"
    *ngIf="(layerOrderMode$ | async)">
</div>